import auth from "./AuthAPI.js";
import Http from "./Http.js";
import * as APPCONFIG from "../config/app-config.js";
import api from "./BaseAPI.js";
import { CHAT_URL } from "../chatPanel/src/config/config.js";
class MyYuukke {
  searchUsers(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/searchUsers`,
      data: formValues,
    });
  }
  searchUsersV2(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getFriendsDetailsFilterV2`,
      data: formValues,
    });
  }

  searchAllUsers(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      // url: `${APPCONFIG.API_URL}api/getSearchUserByType`,
      url: `${APPCONFIG.API_URL}api/connection_filter/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }
  //exit group
  exitGroup(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/exitGroup`,
      data: formValues,
    });
  }
  //remove user in this group
  removeUser(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/removeUserInGroup`,
      data: formValues,
    });
  }
  //getRequestById
  getRequestById(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getRequestbyId`,
      data: formValues,
    });
  }
  //RequestSubjects
  RequestSubject(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/requestedSubject`,
      data: formValues,
    });
  }
  //RequestRejectedSubjects
  RequestSubjectRejected(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/rejectedSubjectRequest`,
      data: formValues,
    });
  }
  deleteSubjectById(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/deleteSubjectById`,
      data: JSON.stringify(formValues),
    });
  }

  //acceptSubjectRequest
  AcceptSubject(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/acceptedSubject`,
      data: formValues,
    });
  }
  //getAllMemberDetails
  getAllMembersDetails(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/group/memberFilter`,
      // url: `${APPCONFIG.API_URL}api/getAllMembersDetailsByType`,
      data: formValues,
    });
  }

  //getAllRequestSubjects
  getRequestedSubjectsList(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getRequestedSubjectsList`,
      data: formValues,
    });
  }
  storeCallScheduleDetails(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      // url: `${APPCONFIG.API_URL}api/saveCallSchedule`,
      data: formValues,
      config,
    });
  }

  getMembersCount(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/membersCount`,
      data: formValues,
    });
  }

  getCallScheduleDetails(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getallcallScheduleById`,
      data: JSON.stringify(formValues),
    });
  }

  saveMemberList(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/saveOrUpdateMember`,
      data: JSON.stringify(formValues),
    });
  }

  getuserAvailabilities(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getuserAvailabilities`,
      data: JSON.stringify(formValues),
    });
  }

  bookSchedule(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/personToPersonCallSchedule`,
      data: JSON.stringify(formValues),
    });
  }
  bookFriendSchedule(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/personToFriendCallSchedule`,
      data: JSON.stringify(formValues),
    });
  }
  updatePeerSchedule(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/updatePeerSchedule`,
      data: JSON.stringify(formValues),
    });
  }
  cancelSchedule(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/personToPersonCallSchedule`,
      data: JSON.stringify(formValues),
    });
  }

  getMemberList(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getMemberDetailsById`,
      data: JSON.stringify(formValues),
    });
  }

  saveCompetency(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/saveCompetency`,
      data: formValues,
    });
  }
  getJoinCallData(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/meetingJoinCall`,
      data: formValues,
    });
  }

  sendRequest(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/sendrequestOpenGroupMeeting`,
      data: formValues,
    });
  }

  rejectMeeting(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/upcommingCallsReject`,
      data: formValues,
    });
  }
  getGroupDetails(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getGroupDetailsById`,
      data: formValues,
    });
  }

  getPeerGroupDetails(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getPeerScheduleById`,
      data: formValues,
    });
  }

  rescheduleCallScheduleDetails(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/updateGroupSchedule`,
      data: formValues,
      config,
    });
  }

  createCallSchedule(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/createGroupSchedule`,
      data: formValues,
      config,
    });
  }

  saveCallSchedule(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/saveCallSchedule`,
      data: formValues,
      config,
    });
  }

  groupUpdate(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/groupUpdate`,
      data: formValues,
      config,
    });
  }

  deleteGroup(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/groupDelete`,
      data: formValues,
    });
  }
  getAlltypeofCommunity(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getAllCommunity`,
      data: formValues,
    });
  }
  admin_resource_post_delete(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/admin_resource_post_delete`,
      data: formValues,
    });
  }
  requestOrAcceptOrReject(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/group/requestOrAcceptOrReject`,
      data: formValues,
    });
  }


  //getReportEmailByAdmin
  getReportEmail(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getReportEmailByAdmin`,
      data: formValues,
    });
  }

  shareChallengeApplied(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/shareChallengeApplied`,
      data: formValues,
    });
  }
  getResourcePlayList(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getResourcePlayList`,
      data: formValues,
    });
  }
  getResourceByPlaylist(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getResourceByPlaylist`,
      data: formValues,
    });
  }
  work_space_user_list(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/work_space_user_list/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }
  work_space_join_or_unjoin(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL
        }api/work_space_join_or_unjoin/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }
  not_work_space_user_list(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL
        }api/not_work_space_user_list/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }
  work_space_save_or_update(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/work_space_save_or_update`,
      data: formValues,
      config,
    });
  }
  work_space_add_user(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/work_space_add_user/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }
  post_view(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/post_view`,
      data: formValues,
    });
  }
  csv_work_space_add_user(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL
        }api/csv_work_space_add_user/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }
  update_work_space_details(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/update_work_space_details`,
      data: formValues,
      config,
    });
  }
  askHelpDelete(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/askHelp/delete`,
      data: JSON.stringify(formValues),
    });
  }

  isAdmin(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/group/isAdmin`,
      data: formValues,
    });
  }
  getEventList(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/event-details/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }
  getEventVideoList(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getEventVideo`,
      data: formValues,
    });
  }
  getUserSlots() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v4/get_user_availability`,
    });
  }
  saveUserSlots(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/saveEventName/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }
  saveUserDateSlot(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/saveEventDatesandTimes`,
      data: formValues,
    });
  }
  getSlotDetailsById(slug) {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/get_slots/${slug}`,

      // url: `${APPCONFIG.API_URL}auth/getTimeslotByToken/${slug}`,
    });
  }
  saveUserBookingSlots(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/save_user_booking_slots/v2`,
      data: formValues,
    });
  }

  fullBooking(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/full_booking`,
      data: formValues,
    });
  }

  submitProfile(payload) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/provider/profile/submit`,
      data: payload,
    });
  }


  getSlotBasedTimeSlot(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getEventDateList`,
      data: formValues,
    });
  }
  deleteSlotBasedOnTime(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/deleteTimeSlotandDate`,
      data: formValues,
    });
  }
  getRequestList(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v2/booking-slot`,
      data: formValues,
    });
  }


  getNext5DaysBookings(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/next5meeting`,
      data: formValues,
    });
  }


  saveUserAvailability(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL
        }api/save_user_availability/v2/${Http.WORK_SPACE()}`,
      // }api/save_user_availability/${Http.WORK_SPACE()}`,
      data: formValues,
    });
  }

  updatePreference(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL
        }api/v2/save_calendar_preference/${Http.WORK_SPACE()}`,
      data: formValues,
      config,
    });
  }

  addUpdateExtraPage(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/saveExtraPages/${Http.WORK_SPACE()}`,
      data: formValues,
      config,
    });
  }

  deleteExtraPage(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/deleteExtraPage`,
      data: formValues,
    });
  }

  saveCalendarSchedule(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/calendar_schedule`,
      data: formValues,
    });
  }

  confirmExpertBooking(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/confirm-expert-booking`,
      data: formValues,
    });
  }

  getConfirmedExpertBookings(filters = {}) {
  const { status, fromDate, toDate } = filters;
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}auth/expert-bookings`,
    data: {
      status: status && status !== "all" ? status.toUpperCase() : null,
      fromDate: fromDate || null, // "YYYY-MM-DD"
      toDate: toDate || null,
    },
  });
}


  getConfirmedExpertBookingsCount() {

  return auth({
    method: "get",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}auth/expert-bookings-count`,

  });
}


declineExpertBooking({ id }) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}auth/expert-bookings/${id}/decline`,
  });
}


  bookAudit(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/bookaudit/save`,
      data: formValues,
    });
  }

  savePaymentInforMation(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/payment/v2/save_payment_details`,
      data: formValues,
    });
  }
  subscriptionList(slug = "service") {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/v2/subscription-by-type/${slug}`,
    });
  }
  addUserSubscription(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/subscription/v2/add_user_subscription`,
      data: formValues,
    });
  }
  savePaymentInforMationWithoutAuth(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/payment/save_payment_details`,
      data: formValues,
    });
  }
  checkPaymentStatus(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/checkPurchaseValidation`,
      data: formValues,
    });
  }
  getCategoryListV2() {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/v1/filter-category-list`,
    });
  }
  getCalendarServices() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}auth/v1/get_calendar_services`,

    });
  }
  saveUerService(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/save_user_service`,
      data: formValues,
      config,
    });
  }
  getDirectoryCategoryV1() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/category`,
    });
  }


  saveService(formValues, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/save_user_service/${Http.WORK_SPACE()}`,
      data: formValues,
      config,
    });
  }
  getUserService() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/get_user_service`,
    });
  }
  deleteService(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/delete_service`,
      data: formValues,
    });
  }
  getSingleService(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/v1/get_single_service`,
      data: formValues,
    });
  }
  updateDetails(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/save_calendar_details`,
      data: formValues,
    });
  }
  serviceAssessmentAnswer(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/service-assessment-answer`,
      data: formValues,
    });
  }
  getUserBySlug(slug) {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/v1/get-user-details/${slug}`,
    });
  }

  saveServiceRecommendForm(formValues, config) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/save-service-recommend-form`,
      data: formValues,
      config,
    });
  }

  saveServiceReviewForm(formValues, config) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/save-service-review-form`,
      data: formValues,
      config,
    });
  }
  getBookingReview(slug) {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/get-booking-review/${slug}`,
    });
  }
  getServiceRecommendList() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v2/get_service_recommend_list`,
    });
  }
  getServiceReviewList() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v2/get_service_reviewlist`,
    });
  }
  updateErrorStatus(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/payment/update-error-status`,
      data: formValues,
    });
  }
  getServiceDashBoard(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/get_service_dashboard_details`,
      data: formValues,
    });
  }

  getServiceDashBoardPassBook(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/getServiceDashBoardPassBook`,
      data: formValues,
    });
  }
  getServiceChatDetails(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/get_service_chat_details`,
      data: formValues,
    });
  }
  saveServiceChatDetails(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/save_service_chat_details`,
      data: formValues,
    });
  }
  sendMessage(formValues) {
    return api({
      method: "post",
      url: `${CHAT_URL}api/message/`,
      data: formValues,
    });
  }
  getMesageList(senderId, receiverId) {
    return api({
      method: "get",
      url: `${CHAT_URL}api/message/service/${senderId}/${receiverId}`,
    });
  }
  getSlotDetailsByIdV3(slug) {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/v3/get_slots/${slug}`,
    });
  }
  getUserSlotsByEmail(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/v1/get-upcoming-slot-booking`,
      data: formValues,
    });
  }
  cancelSlotBooking(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/v1/cancel-slot-booking`,
      data: formValues,
    });
  }
  rescheduleMeeting(formValues) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/v1/reschedule-meeting`,
      data: formValues,
    });
  }
  generateInvoice(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}generate-invoice`,
      data: formValues,
    });
  }
  updateServiceReview(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/update-service-review`,
      data: formValues,
    });
  }
  updateServiceRecommend(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/v1/update-service-recommend`,
      data: formValues,
    });
  }

  createFollowUpPackage(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}auth/v1/create-follow-up-package`,
      data: formValues,
    });
  }

  updateAiLimit(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/updateAiLimit`,
      data: formValues,
    });
  }

  buyAiCredits(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/ai/payment/create-order`,
      data: formValues,
    });
  }

  reconcileAiCredits(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/ai/payment/reconcile-ai-credits`,
      data: formValues,
    });
  }

  verifyAiCredits(formValues) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/ai/payment/verify`,
      data: formValues,
    });
  }


  getAiLimit() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/getAiLimit`,
    });
  }

  getFollowUpPackage(serviceId, email) {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/v1/get-follow-up-package/${serviceId}?email=${email}`,
    });
  }

  searchServiceByCategoryV2(formValues) {
    return api({
      method: "post",

      url: `${APPCONFIG.API_URL}auth/v1/services/by-category-v2`,
      data: formValues,
    });
  }

  paymentVerify(formValues) {
    return api({
      method: "post",

      url: `${APPCONFIG.API_URL}auth/payment/verify-by-order`,
      data: formValues,
    });
  }

  checkLinkedInConnection() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}auth/linkedin/status`,
    })
  }

  // Your APPCONFIG.API_URL is likely "https://bml.betalearnings.com/bca/bcav2/"
  // But Twitter controller is at "/auth/twitter/status" (no /bcav2/)
  // So derive the base without /bcav2/


  // Result: "https://bml.betalearnings.com/bca/"

  connectLinkedin() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}auth/linkedin`,
    })
  }


  postToLinkedIn(data) {
    return api({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}auth/linkedin/post`,
      data,
    });
  }


  serviceAnalytics() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}service/api/analytics`,

    });
  }


  // ── Provider Profile ──────────────────────────────────────────────────────────

  // ── Provider Profile ──────────────────────────────────────────────────────────

  submitProfile(payload) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/provider/profile/submit`,
      data: payload,
    });
  }

  submitProfileWithVideo(formData) {
    // No Content-Type — browser sets multipart/form-data + boundary automatically
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/provider/profile/submit-with-video`,
      data: formData,
    });
  }

  uploadVideo(userId, videoFile) {
    const fd = new FormData();
    fd.append("video", videoFile);
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/provider/profile/video/${userId}`,
      data: fd,
    });
  }

  deleteVideo(userId) {
    return api({
      method: "delete",
      url: `${APPCONFIG.API_URL}auth/provider/profile/video/${userId}`,
    });
  }

  getProviderProfile(userId) {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/provider/profile/${userId}`,
    });
  }

  // ── Provider/Seller Enquiries & Chat Messaging (Token Free) ───────────

  getProviderEnquiries(payload) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/business-exchange/enquiry/received`,
      data: payload,
    });
  }

  getEnquiryChatHistory(enquiryId, payload) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/business-exchange/enquiry/chat/${enquiryId}`,
      data: payload,
    });
  }

  sendEnquiryChatMessage(payload) {
    return api({
      method: "post",
      url: `${APPCONFIG.API_URL}auth/business-exchange/enquiry/chat/send`,
      data: payload,
    });
  }



   getTopclients() {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/provider/contacts/get-getTopclients`,
    })
  }

saveResource(formData, config) {
    return auth({
      method: "post",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/serviceresource/save`,
      data: formData,
      ...config, 
    });
  }

  getResourceList(calendarId) {
    return auth({
      method: "get",
      headers: Http.AUTH_HEADERS(),
      url: `${APPCONFIG.API_URL}api/serviceresource/calendar/${calendarId}`,
    });
  }

getResourceDownload(uuid) {
    return api({
      method: "get",
      url: `${APPCONFIG.API_URL}auth/serviceresource/download/${uuid}`,
    });
  }

getAgenda(obj) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/v4/get_weekly_agenda`,
    data: obj,
  });
}


// MyYuukke.js
getServiceNotifications() {
  return auth({
    method: "get",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/v1/service-notifications`,
  });
}

clearServiceNotification(id) {
  return auth({
    method: "delete",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/v1/service-notifications/${id}`,
  });
}

clearServiceNotifications() {
  return auth({
    method: "delete",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/v1/service-notifications`,
  });
}


createCalendarDetails(userId) {
  return auth({
    method: "post",
    headers: Http.AUTH_HEADERS(),
    url: `${APPCONFIG.API_URL}api/v4/calendar-details/create`,
    params: { userId }, // sent as ?userId=... to match @RequestParam
  });
}

}

export default new MyYuukke();
